import { apiURL } from './constants';
import axios from 'axios';

function authHeaders() {
  axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
}

/**
 * GET /api/pricing/plans/
 * Permission: pricing_plans_list
 * Filters: active, show_in_menu, search, pricing_rule_search, code, name,
 * name_ar, description, description_ar, menu_label_en, menu_label_ar,
 * menu_order, created_at_after, created_at_before, modified_at_after,
 * modified_at_before, ordering, page, page_size
 */
export async function listPricingPlans(params = {}) {
  authHeaders();
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      searchParams.append(k, v);
    }
  });
  const q = searchParams.toString();
  const url = `${apiURL}/api/pricing/plans/${q ? `?${q}` : ''}`;
  return axios.get(url, { withCredentials: true });
}

/**
 * GET /api/pricing/plans/{id}/
 * Permission: pricing_plans_view
 */
export async function getPricingPlan(id) {
  authHeaders();
  return axios.get(`${apiURL}/api/pricing/plans/${id}/`, { withCredentials: true });
}

/**
 * POST /api/pricing/plans/
 * Permission: pricing_plans_create
 */
export async function createPricingPlan(data) {
  authHeaders();
  return axios.post(`${apiURL}/api/pricing/plans/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * PUT /api/pricing/plans/{id}/
 * Permission: pricing_plans_update
 */
export async function updatePricingPlan(id, data) {
  authHeaders();
  return axios.put(`${apiURL}/api/pricing/plans/${id}/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * PATCH /api/pricing/plans/{id}/
 * Permission: pricing_plans_update
 */
export async function patchPricingPlan(id, data) {
  authHeaders();
  return axios.patch(`${apiURL}/api/pricing/plans/${id}/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * DELETE /api/pricing/plans/{id}/ (soft-delete; cascades to linked pricing rules)
 * Permission: pricing_plans_delete
 */
export async function deletePricingPlan(id) {
  authHeaders();
  return axios.delete(`${apiURL}/api/pricing/plans/${id}/`, { withCredentials: true });
}
